import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { formatCurrencyRounded } from "@/lib/utils";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  code: string;
  totalItems: number;
  discrepancyCount: number;
  netDiffValue: number;
  isSubmitting: boolean;
  onConfirm: () => void;
}

export function StockOpnameCompleteDialog({
  open,
  onOpenChange,
  code,
  totalItems,
  discrepancyCount,
  netDiffValue,
  isSubmitting,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Selesaikan Stock Opname?</DialogTitle>
          <DialogDescription className="space-y-2 text-xs">
            <p>
              Anda akan menyelesaikan sesi stock opname{" "}
              <span className="font-bold text-foreground">{code}</span>.
            </p>
            <div className="space-y-1 rounded-md border bg-muted/40 p-2.5 font-mono text-xs">
              <div>Total Barang: {totalItems}</div>
              <div>Barang Selisih: {discrepancyCount}</div>
              <div>
                Estimasi Nilai Selisih: {formatCurrencyRounded(netDiffValue)}
              </div>
            </div>
            <p className="font-medium text-amber-600 dark:text-amber-500">
              Peringatan: Selisih stok fisik akan otomatis diposting ke kartu
              stok sebagai mutasi opname permanen. Setelah selesai, sesi ini
              tidak dapat diubah kembali.
            </p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            size="sm"
            disabled={isSubmitting}
            onClick={() => onOpenChange(false)}
          >
            Batal
          </Button>
          <Button
            size="sm"
            onClick={onConfirm}
            disabled={isSubmitting}
            className="bg-emerald-600 text-white hover:bg-emerald-700"
          >
            {isSubmitting ? "Memproses..." : "Ya, Selesaikan & Posting"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
